import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { HttpClientModule } from '@angular/common/http';

import { HomeRoutingModule } from './home-routing.module';
import { HTTP_INTERCEPTORS } from '@angular/common/http';
import { JwtInterceptor } from '../shared/guards/jwt.interceptor';
import { HomeComponent } from './home.component';
import { AuthCoreModule } from '../core/auth-core/auth-core.module';
import { SharedModule } from '../shared/shared.module';
import { HeaderInterceptor } from '../shared/guards/header-interceptor';
import { TranslatePdfComponent } from './journey/translate-pdf/translate-pdf.component';
import { CortevaDbComponent } from './journey/corteva-db/corteva-db.component';
import { JourneyService } from './journey/journey.service';
import { JourneyCoreModule } from '../core/journey-core/journey-core.module';

@NgModule({
  declarations: [HomeComponent, TranslatePdfComponent, CortevaDbComponent],
  imports: [CommonModule, FormsModule, HttpClientModule, AuthCoreModule, SharedModule, HomeRoutingModule, JourneyCoreModule],
  providers: [
    JourneyService,
    { provide: HTTP_INTERCEPTORS, useClass: JwtInterceptor, multi: true },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: HeaderInterceptor,
      multi: true,
    },
  ],
})
export class HomeModule {}

